export const getKeywordGroupsStyles = () => ({
  container: {
    marginTop: 20,
  },
  divider: {
    marginTop: 16,
    marginBottom: 8,
  },
});
